import { Component, inject, Input } from '@angular/core';
import { L10N_LOCALE, L10nLocale } from 'angular-l10n';

@Component({
  selector: 'app-info-card',
  templateUrl: './info-card.component.html',
  styleUrl: './info-card.component.scss',
  standalone: false
})
export class InfoCardComponent {
  public locale: L10nLocale = inject(L10N_LOCALE);
  @Input() level: 'info' | 'warning' | 'error' = 'info';
  @Input() title: string = undefined;
  @Input() message: string = undefined;
  @Input() maxWidth: string = 'unset';
  @Input() messages: string[] = [];
  @Input() hideTitle = false;
  @Input() singleLine = false;
  @Input() singleLinePadding: string = '';
}
